import { FileSpreadsheet, Plus, Sparkles, Upload } from "lucide-react";

const btn = "btn-brutal font-display uppercase font-bold inline-flex items-center gap-2 disabled:opacity-40 disabled:cursor-not-allowed";

// Importblok: links groot de AI-route (aanbevolen), rechts de Excel-route met de stappen onder elkaar.
// variant "start" (nog geen data: startkaart "Hoe wil je beginnen?") of "compact" (boven een gevulde tabel).
export default function ImportHub({ variant = "compact", testid = "import-hub", ai, excel, manual, locked = false, lockedHint }) {
  const start = variant === "start";
  const disabled = locked;
  return (
    <section data-testid={testid} className={`border-b-2 border-foreground bg-muted/30 ${start ? "p-5" : "px-5 py-3"}`}>
      {start && (
        <div className="mb-4">
          <div className="stat-label">Nog geen gegevens</div>
          <h3 className="font-display font-black text-2xl uppercase tracking-tight">Hoe wil je beginnen?</h3>
          {locked && lockedHint && <p className="text-xs text-destructive mt-1" data-testid={`${testid}-locked`}>{lockedHint}</p>}
        </div>
      )}
      <div className="grid md:grid-cols-5 gap-3">
        <button type="button" onClick={ai.onClick} data-testid={`${testid}-ai`} title={ai.title}
          className={`md:col-span-3 text-left border-2 border-foreground heavy-shadow p-4 flex gap-4 items-center transition-colors ${ai.muted ? "bg-primary/60 text-primary-foreground" : "bg-primary text-primary-foreground hover:bg-primary/90"}`}>
          <span className="shrink-0 w-12 h-12 border-2 border-primary-foreground/60 inline-flex items-center justify-center"><Sparkles className={start ? "w-7 h-7" : "w-6 h-6"} /></span>
          <span className="min-w-0 flex-1">
            <span className="flex items-center gap-2 flex-wrap">
              <span className={`font-display font-black uppercase tracking-tight ${start ? "text-2xl" : "text-lg"}`}>{ai.label}</span>
              <span className="px-1.5 py-px bg-primary-foreground text-primary text-[9px] font-black uppercase tracking-widest">Aanbevolen</span>
              {ai.badge && <span className="px-1.5 py-px bg-background text-foreground text-[9px] font-black uppercase tracking-widest" data-testid={`${testid}-ai-badge`}>{ai.badge}</span>}
            </span>
            <span className={`block text-primary-foreground/90 ${start ? "text-sm mt-1" : "text-xs mt-0.5"}`}>{ai.description}</span>
          </span>
        </button>
        <div className="md:col-span-2 border-2 border-foreground bg-card p-3 flex flex-col gap-2" data-testid={`${testid}-excel`}>
          <div className="stat-label">{excel.title || "Zelf invullen of Excel"}</div>
          <button type="button" onClick={excel.onTemplate} data-testid={`${testid}-template`} className={`${btn} bg-background text-foreground px-3 py-1.5 text-xs justify-start`}>
            <FileSpreadsheet className="w-4 h-4" /> 1. {excel.templateLabel || "Sjabloon downloaden"}
          </button>
          <button type="button" onClick={excel.onImport} disabled={disabled} data-testid={`${testid}-import`} title={excel.importTitle}
            className={`${btn} bg-secondary text-secondary-foreground px-3 py-1.5 text-xs justify-start`}>
            <Upload className="w-4 h-4" /> 2. {excel.importLabel || "Ingevuld sjabloon importeren"}
            {excel.folderName && <span className="text-[10px] font-mono-num normal-case tracking-normal opacity-80 truncate max-w-[110px]">· {excel.folderName}</span>}
          </button>
          {manual && (
            <button type="button" onClick={manual.onClick} disabled={disabled} data-testid={`${testid}-manual`} className={`${btn} bg-background text-foreground px-3 py-1.5 text-xs justify-start`}>
              <Plus className="w-4 h-4" /> {manual.label}
            </button>
          )}
          {excel.alt && (
            <p className="text-[10px] text-muted-foreground leading-snug" data-testid={`${testid}-alt`}>
              {excel.alt.label}:{" "}
              <button type="button" onClick={excel.alt.onTemplate} data-testid={`${testid}-alt-template`} className="underline hover:text-foreground">sjabloon</button>
              {" · "}
              <button type="button" onClick={excel.alt.onImport} disabled={disabled} data-testid={`${testid}-alt-import`} className="underline hover:text-foreground disabled:opacity-40">importeren</button>
            </p>
          )}
        </div>
      </div>
    </section>
  );
}
